/**
 * The external dependencies.
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormDeploymentCancellation from "components/form/FormDeploymentCancellation";

/**
 * @class      ModalDeploymentCancellation (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalDeploymentCancellation = (props) => {
  return (
    <ModalFrame>
      <FormDeploymentCancellation />
    </ModalFrame>
  );
};

export default ModalDeploymentCancellation;
